import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";

const CONTENT = [
  {
    title: "Definisi",
    content: (
      <React.Fragment>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Kecuali dengan tegas dinyatakan lain, seluruh istilah yang
          didefiniskan dalam syarat dan ketentuan ini mempunyai arti sebagai
          berikut:
        </div>
        <ul className="sub-list">
          <li className="text-primary text-size-sub-body-2">
            <div>
              <strong>PT Pohon Dana Indonesia</strong> (selanjutnya disebut Kami
              atau <strong>POHON DANA</strong>) adalah Penyelengara layanan
              Pendanaan Bersama Berbasis Teknologi Informasi (LPBBTI) merupakan
              Badan Hukum Indonesia yang telah berizin dan diawasi oleh Otoritas
              Jasa Keuangan dan/atau otoritas lainnya sehingga dapat melakukan
              kegiatan usahanya sebagai penyedia, pengelola, dan pengoperasian
              layanan yang disediakan melalui layanan digital.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <strong>“Layanan Pohondana”</strong> adalah layanan LPBBTI yang
              Kami sediakan dan tawarkan kepada Anda dari waktu ke waktu pada
              platform Pohondana yang dapat diakses melalui laman website
              www.pohondana.id.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <strong>
                “Layanan Pendanaan Bersama Berbasis Teknologi Informasi”
              </strong>{" "}
              adalah layanan jasa keuangan non bank dengan tujuan untuk
              mempertemukan Pemberi Dana dengan Penerima Dana dalam hal
              melakukan pendanaan konvensional yang dilakukan secara elektronik
              dengan menggunakan internet.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <strong>“Pengguna ( selanjutnya disebut Anda )”</strong> adalah
              subjek hukum yang terdaftar dan memiliki akun sebagai pengguna
              platform Pohondana, baik terdaftar sebagai Penerima Dana maupun
              sebagai Pemberi Dana dengan syarat wajib mematuhi dan menyetujui
              syarat dan ketentuan dalam menggunakan layanan yang tersedia dalam
              Platform.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <strong>“Pemberi Dana”</strong> adalah orang perorangan, badan
              hukum, dan atau badan usaha baik yang bekedudukan di Indonesia
              maupun Asing serta Lembaga Internasional yang melakukan pendanaan
              melalui Platform Pohondana untuk disalurkan kepada Penerima Dana.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <strong>“Penerima Dana”</strong> adalah orang perorangan (WNI),
              badan hukum dan badan usaha Indonesia serta berdomisili di
              Indonesia yang menerima sejumlah Dana dari Pemberi Dana melalui
              layanan Pohondana.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <strong>“Data Pribadi”</strong> adalah setiap dan semua data
              informasi pribadi tentang Anda dan/atau Penerima Manfaat, baik
              bersifat umum maupun spesifik yang telah dikumpulkan melalui
              platform bertujuan untuk mengidentifikasi, termasuk namun tidak
              terbatas pada nama, alamat, tanggal lahir, pekerjaan, sumber
              penghasilan (apabila Anda merupakan individu), data, dokumen
              identitas perwakilan, perizinan, data keuangan, identifikasi
              pajak, dan dokumen identitas perusahaan (apabila Anda merupakan
              Badan Hukum), nomor telepon, nomor ponsel, alamat korespondensi
              (e-mail), Surat Kuasa, data identitas, dan data keuangan (Apabila
              Anda bertindak mewakili Penerima Manfaat), dan informasi lain yang
              dipersyaratkan pada saat proses registrasi akun dan permohonan
              Pendanaan yang mungkin dapat mengidentifikasikan Anda sebagai
              Pengguna Platform.
            </div>
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Persetujuan Penggunaan Layanan",
    content: (
      <React.Fragment>
        <ul className="sub-list">
          <li className="text-primary text-size-sub-body-2">
            Anda sebagai pengguna, maka Anda bertanggung jawab secara penuh atas
            tindakan Anda dalam memanfaatkan layanan Pohondana.
          </li>
          <li className="text-primary text-size-sub-body-2">
            Anda dilarang untuk menggunakan layanan Pohondana untuk kepentingan
            yang bertentangan secara hukum serta merugikan Pohondana serta
            Afiliasinya.
          </li>
          <li className="text-primary text-size-sub-body-2">
            Apabila Anda melanggar poin 2 sebagaimana diatas, segala akibat dan
            kerugian yang timbul menjadi tanggung jawab Anda sepenuhnya dan
            membebaskan Pohondana dari segala tuntutan.
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              Layanan yang terdapat pada situs ini ditujukan dan digunakan oleh
              :
              <ul className="sub-list2">
                <li>
                  Pengguna Individu yang telah dewasa yaitu berusia minimal 18 (
                  delapan belas ) tahun dan telah memiliki penghasilan minimal
                  Rp. 3.000.000 (tiga juta rupiah) per bulan.
                </li>
                <li>
                  Badan hukum Indonesia, badan usaha Indonesia, badan usaha
                  asing, dan/atau badan hukum asing, diwakili oleh perwakilan
                  yang sah dan memiliki kapasitas hukum untuk mengadakan
                  perjanjian secara mengikat, khususnya penggunaan Layanan yang
                  tersedia dalam Paltform, dan berlokasi dalam wilayah Republik
                  Indonesia. Segala hal yang terkait dengan, akses ke atau
                  penggunaan dari Platform dan Layanan diatur dan disusun sesuai
                  dengan hukum Indonesia tanpa mempengaruhi prinsip hukum
                  internasional lainnya.
                </li>
                <li>
                  Anda akan mengakses dan/atau menggunakan Layanan dalam
                  Platform Kami hanya untuk tujuan yang sah dan tidak
                  bertentangan dengan ketentuan hukum yang berlaku di Indonesia.
                </li>
                <li>
                  Anda wajib mengakses Layanan Kami melalui perangkat elektronik
                  milik Anda pribadi.
                </li>
                <li>
                  Kami memberikan batasan Pendanaan kepada setiap Pengguna
                  berdasarkan kriteria dan pertimbangan Kami untuk dapat
                  digunakan dalam berbagai tenor Pendanaan.
                </li>
                <li>
                  Anda hanya dapat mengajukan permohonan Pendanaan selama limit
                  pendanaan aktif masih tersedia.
                </li>
                <li>
                  Jangka waktu Pendanaan yang diberikan menyesuaikan dengan
                  tempo yang tertera dalam Platform Kami.
                </li>
                <li>
                  Setiap Pendanaan yang telah dicairkan oleh Pemberi Dana
                  dan/atau diterima oleh Penerima Dana tidak dapat dibatalkan
                  atau dikembalikan (refund) dalam bentuk apapun, kecuali jika
                  disepakati lain oleh POHONDANA dan Pemberi Dana.
                </li>
                <li>
                  Dengan membuat dan memelihara akun melalui Platform POHONDANA,
                  Anda menyatakan dan menjamin bahwa Anda memenuhi persyaratan
                  kelayakan di atas dan diizinkan.
                </li>
                <li>
                  Anda juga secara tegas memberi wewenang kepada Kami untuk
                  menggunakan berbagai cara yang diperlukan untuk memverifikasi
                  identitas Anda melalui penyedia informasi pihak ketiga, baik
                  untuk kepentingan penagihan, penggunaan Tanda Tangan
                  Elektronik yang diamankan oleh Sertifikat Elektronik, Credit
                  Scoring, Pemeriksaan Sistem Layanan Informasi Keuangan (SLIK),
                  Fintech Data Center (FDC), dan penyedia layanan pendukung
                  lainnya sebagai bentuk kewajiban penyelenggara dalam memenuhi
                  kepatuhan atas peraturan yang berlaku.
                </li>
                <li>
                  Anda tidak diperkenankan untuk mengakses, menggunakan,
                  mengumpulkan dan/atau mengambil data pada Platform POHONDANA
                  untuk kepentingan selain dari maksud dan tujuan Layanan Kami.
                </li>
                <li>
                  Hak Kekayaan Intelektual yang meliputi identitas Kami atau
                  merek POHONDANA beserta turunannya, Hak Cipta atas program
                  komputer beserta sistem lainnya adalah Hak Kekayaan
                  Intelektual (“Aset Tak Berwujud”) milik PT Pohon Dana
                  Indonesia. Anda tidak diizinkan menggunakan dan/atau melakukan
                  pencatutan nama, logo, merek, hak cipta, desain terdaftar atau
                  segala jenis hak atas kekayaan intelektual lainnya yang secara
                  sah telah Kami miliki, tanpa persetujuan tertulis terlebih
                  dahulu dari Kami dan/atau afiliasi dan/atau secara melawan
                  hukum untuk tujuan dan kepentingan pribadi.
                </li>
                <li>
                  Anda memahami, mengakui, dan setuju bahwa peran POHON DANA
                  hanya sebagai fasilitator dan bersifat administratif yang
                  mengatur perjanjian antara Penerima Dana dan Pemberi Dana
                  dalam Perjanjian Pendanaan terkait, sesuai dengan Peraturan
                  Otoritas Jasa Keuangan Nomor 40 tahun 2024
                </li>
              </ul>
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            Kami berharap bahwa dalam setiap pengaksesan dan penggunaan Layanan
            POHONDANA dapat Anda dijadikan sebagai salah satu alternatif sarana
            keuangan terbaik sesuai kebutuhan. Anda sepenuhnya bertanggung jawab
            atas setiap dan seluruh keputusan terkait permohonan Pendanaan,
            termasuk dalam menyetujui Syarat dan Ketentuan, Kebijakan Privasi,
            Perjanjian Pendanaan, maupun ketentuan dan kebijakan lainnya yang
            telah Kami tetapkan.
          </li>
          <li className="text-primary text-size-sub-body-2">
            Anda menyadari sepenuhnya pengaksesan dan penggunaan Layanan Kami.
            Tidak ada situasi atau keadaan apapun di luar kendali, termasuk
            kekhilafan, kelalaian atau kekeliruan Anda yang membuat Kami
            bertanggung jawab atas kemungkinan kerugian yang Anda alami akibat
            pengambilan keputusan yang Anda lakukan sendiri dalam penuh
            kesadaran dan sesuai dengan konsensus yang Anda berikan. Kami juga
            tidak bertanggung jawab atas segala kerugian yang ditimbulkan oleh
            kegagalan atas akses terhadap Platform dan penggunaan Platform oleh
            Anda sebagai suatu tindakan di luar kendali Kami.
          </li>
          <li className="text-primary text-size-sub-body-2">
            Segala risiko kesalahpahaman, kekeliruan, kelalaian, kerusakan,
            biaya atau kerugian yang ditimbulkan akibat penggunaan Platform atau
            sehubungan dengan transaksi Pendanaan antara Anda dan Penerima Dana
            (sebagaimana berlaku), sepenuhnya merupakan risiko yang Anda sadari
            sehingga harus Anda tanggung dan telah sepenuhnya dinyatakan dalam
            Syarat dan Ketentuan ini dan oleh karenanya Kami tidak berkewajiban
            untuk bertanggung jawab atas hal tersebut.
          </li>
          <li>
            Kami tidak bertanggung jawab atas kehilangan atau kerugian yang
            disebabkan karena kelalaian, kekeliruan, dan/atau tindakan
            pengabaian maupun kesengajaan yang Anda lakukan dalam mengamankan
            Informasi Pribadi Anda, perangkat elektronik yang digunakan untuk
            mengakses Platform, dan koneksi internet dari kejahatan siber secara
            tidak terbatas pada phising, virus, trojan, malwares, bug, dan/atau
            berbagai kejahatan siber lainnya. Anda sangat disarankan untuk
            menjalankan dan menerapkan alat atau proteksi tambahan dalam
            mengambil tindakan pencegahan ketika mengakses koneksi internet
            publik.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Kebijakan Perlindungan Data Pribadi",
    content: (
      <React.Fragment>
        <ul className="sub-list">
          <li className="text-primary text-size-sub-body-2">
            <div>
              Seluruh Informasi Pribadi dan data lainnya yang diperoleh dan
              terkumpul dalam Platform akan Kami simpan dan pergunakan
              sebagaimana mestinya sesuai dengan tujuan dan kepentingan proses
              Pendanaan yang tertuang dalam Peraturan Otoritas Jasa Keuangan
              Nomor 40 Tahun 2024 tentang Layanan Pendanaan Bersama Berbasis
              Teknologi Informasi (“POJK LPBBTI”),Undang-Undang Nomor 1 Tahun
              2024 tentang Perubahan kedua tasa Undang-Undang Nomor 11 Tahun
              2008 tentang Informasi dan Transaksi elektronik (“UU ITE”),
              Undang-Undang Nomor 27 Tahun 2022 tentang Pelindungan Data Pribadi
              (“UU PDP”), Peraturan Pemerintah Nomor 71 Tahun 2019 tentang
              Penyelenggaraan Sistem dan Transaksi Elektronik (“PP PSTE”),
              Peraturan Menteri Komunikasi dan Informatika RI Nomor 20 Tahun
              2016 tentang Perlindungan Data Pribadi Dalam Sistem Elektronik
              (“PMKI 20/2016”), serta ketentuan peraturan perundang-undangan
              lainnya yang berlaku, termasuk setiap aturan turunan, pelaksana,
              maupun perubahannya dari waktu ke waktu (apabila ada).
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            Kami berkomitmen dan menghormati setiap Data Privasi Anda sesuai
            ketentuan Pelindungan Data Pribadi yang berlaku. Kami tidak
            mengumpulkan Informasi Pribadi tentang Anda, kepada Kami sesuai
            tujuan penyediaan Layanan. Kami hanya akan menggunakan informasi
            yang Anda berikan untuk tujuan pemberian Layanan. Ketentuan lebih
            lanjut sehubungan dengan Kebijakan Privasi akan ditampilkan secara
            terpisah tetapi masih menjadi bagian dari Platform Kami.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Hak Kekayaan Intelektual",
    content: (
      <React.Fragment>
        <ul className="sub-list">
          <li className="text-primary text-size-sub-body-2">
            <div>
              <div className="fw-extra-bold">
                Kepemilikan Hak Kekayaan Intelektual
              </div>
              <ul className="sub-list2">
                <li>
                  Semua hak kekayaan intelektual dalam platform, termasuk namun
                  tidak terbatas pada: teks, grafis, logo, ikon, gambar, audio
                  klip, perangkat lunak, basis data, serta teknologi yang
                  digunakan, adalah milik POHONDANA atau pihak ketiga yang
                  bekerja sama.
                </li>
                <li>
                  Tidak ada bagian dari platform ini yang dapat dianggap sebagai
                  pemberian lisensi atau hak kepada pengguna untuk menggunakan
                  Hak Kekayaan Intelektual tersebut, kecuali dengan persetujuan
                  tertulis sebelumnya.
                </li>
              </ul>
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <div className="fw-extra-bold">Batassan Penggunaan</div>
              Pengguna hanya diberikan lisensi terbatas, non-eksklusif, tidak
              dapat dipindahtangankan, untuk mengakses dan menggunakan platform
              untuk tujuan memanfaatkan layanan yang disediakan, bukan untuk
              tujuan komersial lainnya.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <div className="fw-extra-bold">Pengguna Dilarang</div>
              <ul className="sub-list2">
                <li>
                  Menyalin, mengubah, menggandakan, menerbitkan ulang,
                  mengunggah, memposting, mengirimkan, atau mendistribusikan
                  materi apapun dari platform tanpa izin tertulis.
                </li>
                <li>
                  Melakukan rekayasa balik (reverse engineering), dekompilasi,
                  atau mencoba mendapatkan kode sumber dari perangkat lunak yang
                  digunakan dalam platform.
                </li>
                <li>
                  Menghapus, mengaburkan, atau mengubah pemberitahuan hak cipta,
                  merek dagang, atau pemberitahuan hak kepemilikan lainnya.
                </li>
              </ul>
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <div className="fw-extra-bold">Merek Dagang dan Logo</div>
              <ul className="sub-list2">
                <li>
                  Nama perusahaan, merek dagang, logo, dan nama produk atau
                  layanan yang ditampilkan dalam platform adalah milik penyedia
                  layanan atau pemberi lisensi pihak ketiga.
                </li>
                <li>
                  Penggunaan merek dagang tanpa izin tertulis tegas dari
                  pemiliknya dilarang dan dapat menimbulkan konsekuensi hukum.
                </li>
              </ul>
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <div className="fw-extra-bold">
                Konten yang Dikirimkan oleh Pengguna
              </div>
              Jika pengguna mengirimkan konten (seperti ulasan, komentar, atau
              masukan) ke platform, pengguna menjamin bahwa konten tersebut:
              <ul className="list-abjad">
                <li>Tidak melanggar hak kekayaan intelektual pihak ketiga.</li>
                <li>
                  Memberikan hak non-eksklusif, bebas royalti, dapat
                  dipindahtangankan, dan berlaku secara global kepada penyedia
                  layanan untuk menggunakan, mereproduksi, memodifikasi,
                  menyesuaikan, menerbitkan, menerjemahkan, mendistribusikan,
                  dan menampilkan konten tersebut dalam bentuk apapun.
                </li>
              </ul>
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <div className="fw-extra-bold">Penegakan Hak</div>
              Penyedia layanan berhak mengambil tindakan hukum jika terjadi
              pelanggaran hak kekayaan intelektual, termasuk tetapi tidak
              terbatas pada tuntutan ganti rugi, pemblokiran akses pengguna, dan
              laporan kepada pihak berwenang.
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              <div className="fw-extra-bold">
                Tanggung Jawab atas Pelanggaran
              </div>
              Jika pengguna melanggar ketentuan terkait Hak Kekayaan
              Intelektual, pengguna bertanggung jawab penuh atas kerugian yang
              ditimbulkan kepada penyedia layanan atau pihak ketiga, termasuk
              biaya hukum dan ganti rugi.
            </div>
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Pembatasan dan Penghentian Akses",
    content: (
      <React.Fragment>
        <ul className="sub-list">
          <li className="text-primary text-size-sub-body-2">
            <div>
              Kami berhak, dengan kebijaksanaan sepenuhnya, untuk membatasi,
              menangguhkan, atau menghentikan akses Pengguna terhadap seluruh
              atau sebagian dari Platform dan/atau Layanan, tanpa kewajiban
              untuk memberikan pemberitahuan terlebih dahulu, dalam hal:
              <ul className="list-abjad">
                <li>
                  Pengguna melanggar ketentuan dalam Syarat dan Ketentuan ini,
                  Kebijakan Privasi, atau ketentuan hukum dan peraturan
                  perundang- undangan yang berlaku;
                </li>
                <li>
                  Terindikasi adanya aktivitas mencurigakan, tidak sah, atau
                  melanggar hukum yang dilakukan melalui akun Pengguna;
                </li>
                <li>
                  Adanya permintaan dari instansi pemerintah, aparat penegak
                  hukum, atau berdasarkan putusan pengadilan;
                </li>
                <li>
                  Pengguna bertindak atau berpotensi bertindak dengan cara yang
                  merugikan Penyelenggara, mitra Penyelenggara, atau pihak
                  ketiga lainnya;
                </li>
                <li>
                  Penggunaan Platform dan/atau Layanan tidak sesuai dengan
                  tujuan yang sah dan wajar.
                </li>
              </ul>
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            <div>
              Pembatasan sebagaimana dimaksud dalam ayat (1) dapat berupa, namun
              tidak terbatas pada:
              <ul className="list-abjad">
                <li>Pembekuan sementara akun Pengguna;</li>
                <li>Pembatasan penggunaan fitur tertentu;</li>
                <li>Penangguhan transaksi;</li>
                <li>Pemblokiran permanen akun Pengguna.</li>
              </ul>
            </div>
          </li>
          <li className="text-primary text-size-sub-body-2">
            Penyelenggara berhak untuk menolak pendaftaran kembali dari Pengguna
            yang aksesnya pernah dibatasi atau dihentikan akibat pelanggaran
            ketentuan ini, kecuali ditentukan lain oleh Penyelenggara
            berdasarkan kebijakannya sendiri.
          </li>
          <li className="text-primary text-size-sub-body-2">
            Untuk tujuan penghentian, Anda dan Perusahaan setuju untuk
            mengesampingkan ketentuan Pasal 1266 Kitab Undang-Undang Hukum
            Perdata sehingga penghentian Ketentuan Layanan ini akan efektif
            tanpa harus mendapatkan persetujuan pengadilan, lembaga lain atau
            pertimbangan lainnya di dalam wilayah Republik Indonesia.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Ganti Rugi",
    content: (
      <React.Fragment>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Anda sepakat untuk melepaskan, membebaskan dan mengganti kerugian
          Kami, afiliasinya, pemegang sahamnya, direktur, komisaris, karyawan,
          subkontraktor, pemasok, agen dari dan atas segala bentuk tuntutan,
          gugatan, klaim, kerugian, ganti rugi, termasuk biaya konsultan hukum,
          yang disebabkan oleh pelanggaran Syarat dan Ketentuan ini oleh Anda
          dan ketentuan lain yang ditetapkan oleh Kami.
        </div>
      </React.Fragment>
    ),
  },
  {
    title: "Dokumen Lain yang Berlaku",
    content: (
      <React.Fragment>
        <div>
          Pemberlakuan Syarat dan Ketentuan ini tidak serta merta terlepas dari
          ketentuan lain yang telah Kami tetapkan dan berlaku terhadap
          penyediaan Layanan melalui Platform dan dianggap sebagai satu kesatuan
          ketentuan penggunaan Layanan maupun Platform, antara lain mencakup:
          <ul className="list-numbering">
            <li>Kebijakan Privasi;</li>
            <li>Perjanjian Pendanaan; dan</li>
            <li>Dokumen lainnya yang termuat dalam Platform ini.</li>
          </ul>
        </div>
        <div>
          Jika terdapat pertentangan ketentuan yang diatur dalam Syarat dan
          Ketentuan ini dengan dokumen lain yang Kami berlakukan, maka ketentuan
          lainnya yang tidak bertentangan tetap diberlakukan dan Kami akan
          melakukan penyesuaian lebih lanjut serta dalam hal terdapat kebijakan
          untuk aspek-aspek khusus dari Layanan, maka kebijakan khusus tersebut
          yang akan diberlakukan sementara hingga Kami sudah memenuhi
          penyesuaian yang ada.
        </div>
      </React.Fragment>
    ),
  },
  {
    title: "Pernyataan dan Jaminan",
    content: (
      <React.Fragment>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Anda sebagai Pengguna Platform memberikan persetujuan, menyatakan, dan
          menjamin hal-hal berikut ini:
        </div>
        <ul className="sub-list">
          <li>
            Memberikan akses kepada Kami untuk dapat memperoleh, mengumpulkan,
            memproses, mengelola, menggunakan, mengolah, menganalisis,
            menyimpan, menghapus, memusnahkan, dan mengungkapkan secara terbatas
            Informasi Pribadi Anda, termasuk terhadap akses kamera, lokasi, dan
            mikrofon pada device Anda. Dalam hal terdapat pengecualian ketentuan
            peraturan perundang-undangan dan/atau permintaan dari Pengadilan,
            Lembaga, Badan, dan/atau Otoritas berwenang, maka Kami maupun pihak
            ketiga yang bekerja sama dengan POHONDANA berhak untuk melakukan
            pengungkapan Informasi Pribadi Anda secara tidak terbatas tanpa
            didahului pemberitahuan maupun persetujuan dari Anda.
          </li>
          <li>
            Anda memastikan bahwa Anda selaku Pemohon/Penerima Dana dan atau
            Pemberi Dana adalah entitas atau subjek hukum yang bebas, tidak
            dalam keadaan bermasalah baik dari segi kesehatan keuangan maupun
            keadaan lainnya, bukan merupakan bagian dari suatu kelompok
            berbahaya, dan tidak terlibat dalam kejahatan atau aktivitas
            keuangan ilegal dalam bentuk apa pun seperti perjudian online,
            tindak pidana pencucian uang, pendanaan terorisme, pendanaan
            proliferasi senjata pemusnah massal maupun berbagai bentuk kejahatan
            atau aktivitas ilegal lainnya serta tidak dinyatakan wanprestasi
            oleh pihak ketiga manapun. Anda memastikan bahwa nomor rekening
            pencairan dana yang dicantumkan pada Platform POHONDANA adalah benar
            milik dan atas nama Anda selaku Pemohon dan/atau Penerima Dana yang
            sah, bukan untuk kepentingan pihak lain.
          </li>
          <li>
            Anda menjamin Seluruh Informasi Pribadi yang Anda berikan melalui
            Platform Kami merupakan Informasi Pribadi yang bersifat lengkap,
            akurat, utuh, relevan, sesuai keadaan atau kepemilikan sebenarnya,
            tidak menyesatkan, bukan hasil tindak manipulasi, pemalsuan, namun
            tidak terbatas pada keakuratan data pribadi yang anda berikan atas
            pemrosesan untuk tujuan penerbitan sertifikat elektronik serta
            layanan lain yang melekat pada sertifikat elektronik yang dilakukan
            oleh penyelenggara sertifikat elektronik
          </li>
          <li>
            Anda menyatakan setuju dalam penggunaan tanda tangan elektronik
            tersertifikasi untuk penandatangan perjanjian penyaluran dan atau
            pemberian fasilitas pendanaan melalui Pihak Ketiga penyelenggara
            sertifikat elektronik yang telah bekerjasama dengan Kami.
          </li>
          <li>
            Anda memastikan bahwa pencantuman kontak darurat yang Anda lakukan
            pada saat permohonan Pendanaan melalui Platform Kami telah
            memperoleh persetujuan secara sah dari pihak yang dijadikan sebagai
            kontak darurat disertai konfirmasi lebih lanjut oleh Tim Internal
            POHONDANA terkait pencantuman tersebut.
          </li>
          <li>
            Anda memastikan dan menjamin bahwa permohonan Pendanaan ini
            ditujukan untuk kepentingan pribadi Anda sendiri sesuai dengan
            tujuan yang telah dicantumkan melalui Platform dan/atau apabila Anda
            mewakili pihak lain, maka Anda wajib memberikan Informasi Pribadi
            pihak lain selaku Penerima Manfaat (Beneficial Owner) atas Pendanaan
            disertai klarifikasi dan konfirmasi baik secara langsung maupun
            tidak langsung kepada Kami. Berdasarkan kebijakan Kami, jika Anda
            mewakili kepentingan pihak lain, maka Kami berhak untuk melakukan
            pemeriksaan lebih lanjut dan meminta dokumen tambahan yang
            diperlukan.
          </li>
          <li>
            Layanan Pendanaan melalui Platform POHONDANA adalah transaksi
            keuangan yang bersifat sah dan mengikat, menimbulkan hubungan hukum
            antara Pemberi Dana dengan Penerima Dana sebagaimana diatur dalam
            Perjanjian Pendanaan yang disepakati oleh Para Pihak sehingga dalam
            hal ini Anda selaku Penerima Dana bertanggung jawab penuh atas
            setiap Pendanaan.
          </li>
          <li>
            Anda selaku Penerima Dana bertanggung jawab atas segala kerugian
            disebabkan akibat kelalaian, kekeliruan, dan ketidakhati-hatian Anda
            dalam melakukan transaksi yang terjadi di luar Platform POHONDANA
            dan/atau oknum yang mengatasnamakan POHONDANA sehingga dengan ini
            membebaskan serta melepaskan POHONDANA dari seluruh tuntutan,
            gugatan.
          </li>
          <li>
            Anda menyatakan bahwa Anda telah membaca, memahami, menyetujui, dan
            mematuhi seluruh informasi yang tertera baik pada Syarat dan
            Ketentuan, Perjanjian Pendanaan, Kebijakan Privasi, dan/atau
            ketentuan lainnya yang ada.
          </li>
        </ul>
      </React.Fragment>
    ),
  },
  {
    title: "Hukum yang Berlaku",
    content: (
      <React.Fragment>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Syarat dan Ketentuan ini akan diatur dan ditafsirkan sesuai dengan
          ketentuan Hukum Republik Indonesia
        </div>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Dalam rangka mematuhi gugatan atau tindakan hukum yang terkait
          perselisihan yang timbul akibat atau dalam kaitannya dengan Syarat dan
          Ketentuan ini, setiap pihak akan tunduk pada juridiksi Badan Arbitrase
          Nasional Indonesia (BANI).Arbitrase pada Lembaga Alternatif
          Penyelesaian Sengketa Sektor Jasa Keuangan (LAPS SJK). Para Pihak
          sepakat bahwa Putusan atas Sengketa yang diberikan oleh Mediator atau
          Arbiter adalah putusan yang bersifat final, mengikat dan tidak dapat
          disangkal oleh Para Pihak atau pihak manapun, dan Para Pihak sepakat
          melaksanakan segala upaya yang dibutuhkan untuk memastikan pelaksanaan
          Putusan Arbitrase ataupun Kesepakatan Mediasi tersebut.
        </div>
      </React.Fragment>
    ),
  },
  {
    title: "Pengakhiran",
    content: (
      <React.Fragment>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Anda setuju bahwa jika terdapat pelanggaran oleh Anda berdasarkan
          Syarat dan Ketentuan ini atau berdasarkan peraturan perundang-undangan
          berlaku, maka Kami secara sepihak atas kebijakan Kami dan tanpa
          pemberitahuan terlebih dahulu sebelumnya melakukan penundaan dan/atau
          pemblokiran terhadap pengajuan maupun transaksi Pendanaan Anda hingga
          penghapusan akun Anda pada Layanan Kami, membatasi akses Anda ke
          seluruh Layanan Kami serta menghentikan layanan kepada Anda.
        </div>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Anda dengan ini setuju bahwa kerugian material atau immaterial yang
          timbul dari penghapusan akun Anda dan/atau pembatasan akses yang
          disebutkan di atas sepenuhnya merupakan tanggung jawab Anda.
        </div>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Dalam hal hubungan hukum antara Kami dan Anda telah berakhir atau
          tidak terdapat kewajiban Pendanaan yang harus Anda penuhi kepada Kami
          dan/atau Pemberi Dana, maka Kami dapat melakukan penyimpanan Informasi
          Pribadi Anda untuk jangka waktu 5 (lima) tahun dan dapat melakukan
          penghapusan Informasi Pribadi Anda jika terdapat keadaan telah
          mencapai masa retensi; tujuan pemrosesan informasi pribadi telah
          tercapai; atau terdapat permintaan dari anda selaku pemilik informasi
          pribadi.
        </div>
      </React.Fragment>
    ),
  },
  {
    title: "Hubungi Kami",
    content: (
      <React.Fragment>
        <div className="text-primary text-size-sub-body-2 pt-3">
          Informasi lebih lanjut dapat mengunjungi halaman Kontak Kami.
        </div>
      </React.Fragment>
    ),
  },
];
function TncContent() {
  const sectionRef = useRef<(HTMLDivElement | null)[]>([]);

  const handleClick = (index: number) => {
    if (sectionRef.current[index]) {
      const element = sectionRef.current[index];
      const offset = 60;
      if (element) {
        const top =
          element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  };

  return (
    <React.Fragment>
      <Container className="border-bottom pb-5">
        <div
          style={{ textAlign: "justify" }}
          className="my-5 text-size-body-head-2  "
        >
          <div className="my-2">
            Syarat dan ketentuan ini berisikan kesepakatan Anda dengan Pohondana
            sebagai pengguna, untuk tujuan menggunakan, memanfaatkan dan atau
            mengakses Layanan Pendanaan Bersama Berbasis Teknologi Informasi
            selanjutnya disebut layanan. Dengan tetap mengakses dan atau
            melanjutkan penggunaan layanan, Anda telah menyatakan dan setuju
            atas isi Syarat dan ketentuan Layanan Kami, sehingga Anda dengan ini
            menyatakan telah membaca, mengetahui, memahami, dan menyetujui atas
            syarat dan ketentuan layanan kami.
          </div>
          <div className="my-2">
            Kami sewaktu-waktu dan jika diperlukan dapat melakukan perubahan dan
            penyesuaian atas syarat dan ketentuan ini, baik disertai atau tanpa
            ada pemberitahuan terlebih dahulu kepada Anda, sepanjang isi dari
            syarat dan ketentuan ini tidak bertentangan dengan ketentuan
            peraturan perundang-undangan yang berlaku.{" "}
          </div>
          <div className="my-2">
            Dengan melanjutkan layanan kami, Anda sepakat dan setuju dengan
            Syarat dan Ketentuan ini.
          </div>
        </div>
        <div className="mt-2 text-size-body-head-2 text-primary border-bottom">
          Daftar Isi
        </div>
        <Row>
          <Col>
            <ul className="list-content ps-4">
              {CONTENT.map((a, i) => {
                return (
                  <li
                    key={a.title}
                    onClick={() => handleClick(i)}
                    className="fw-bold cursor-pointer text-size-sub-body-2 pt-2"
                  >
                    {a.title}
                  </li>
                );
              })}
            </ul>
          </Col>
        </Row>
      </Container>

      <Container className="my-5">
        <ul
          className="main-list"
          style={{
            textAlign: "justify",
          }}
        >
          {CONTENT.map((a, i) => {
            return (
              <li
                key={`content-${a.title}`}
                className="mt-4 pb-4 border-bottom"
              >
                <div
                  ref={(el) => {
                    sectionRef.current[i] = el;
                  }}
                >
                  <div className="text-primary fw-extra-bold text-size-sub-headline-2 text-uppercase">
                    {a.title}
                  </div>
                  {a.content}
                </div>
              </li>
            );
          })}
        </ul>
        <div className="my-2 text-primary text-size-sub-body-2 pt-3">
          Syarat dan Ketentuan ini tidak dapat ditarik atau dibatalkan dengan
          sebab apapun juga tanpa persetujuan tertulis dari Perusahaan.
        </div>
      </Container>
    </React.Fragment>
  );
}

export default TncContent;
